import { render } from "./CodeBlock.vue?vue&type=template&id=2ed54298&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=ts"
export * from "./CodeBlock.vue?vue&type=script&lang=ts"

import "./CodeBlock.vue?vue&type=style&index=0&id=2ed54298&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ed54298"

export default script